<template>
  <div class="c-invite-confirm-4-digits">
    <p class="description">
      Precisamos verificar se você realmente é responsável por esse convite 😉
    </p>

    <p>
      <strong>
        Digite os 4 últimos dígitos do telefone de contato a seguir:
      </strong>
    </p>

    <div class="phone-confirmation">
      <div class="phone">Tel.: {{ phoneWithoutMaskX }}</div>
      <div class="otp">
        <BaseOTPInput
          v-model="last4Digits"
          :length="4"
          :hasError="validation.hasError('last4Digits') || !!error"
          :autofocus="true"
          @submit="validate"
        />
      </div>
    </div>
    <p v-if="validation.hasError('last4Digits') || !!error" class="error-label">
      {{ validation.firstError('last4Digits') || error }}
    </p>
    <div class="submit-wrapper">
      <button
        @click="validate"
        :disabled="!canValidate"
        :class="{ 'is-loading': loading }"
        type="button"
        class="button is-primary"
      >
        Validar
      </button>
    </div>
    <button @click="$emit('resetSearch')" class="link" type="button">
      Realizar nova pesquisa
      <base-icon width="12" height="12" name="painel/chevron-left-icon" />
    </button>
  </div>
</template>

<script>
import SimpleVueValidator from 'simple-vue-validator'
import BaseOTPInput from '@/components/BaseOTPInput.vue'
import RsvpApi from '@/lib/api/Rsvp'

const Validator = SimpleVueValidator.Validator

export default {
  mixins: [SimpleVueValidator.mixin],

  components: {
    BaseOTPInput,
  },

  props: {
    invite: {
      type: Object,
      required: true,
    },
  },

  validators: {
    last4Digits(value) {
      return Validator.value(value).digit('Por favor, insira somente números.')
    },
  },

  computed: {
    canValidate() {
      return (
        this.last4Digits.length === 4 &&
        !this.validation.hasError('last4Digits') &&
        !this.loading
      )
    },

    phoneWithoutMaskX() {
      const index = this.invite.phone.indexOf('x')
      if (index !== -1) return this.invite.phone.slice(0, index)
      return this.invite.phone.slice(0, -4)
    },
  },

  data() {
    return {
      last4Digits: '',
      loading: false,
      error: false,
    }
  },

  methods: {
    validate() {
      if (!this.canValidate) return
      this.loading = true
      this.error = false

      const noToken = undefined
      const { wed_id } = this.$route.query
      const api = new RsvpApi(noToken, wed_id)

      api
        .confirmInvite(this.invite.id, this.last4Digits)
        .then((response) => {
          this.$emit('confirmed', response.data)
        })
        .catch((error) => {
          this.error = 'Os dígitos informados estão inválidos.'
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 1000)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-invite-confirm-4-digits {
  p {
    color: $neutral;
    strong {
      color: inherit;
    }
  }
  .description {
    margin-bottom: 40px;
  }
  .phone-confirmation {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 24px 0;
    .phone {
      margin-bottom: 8px;
    }
    @media screen and (min-width: 480px) {
      flex-direction: row;
      .phone {
        margin-bottom: 0;
        margin-right: 8px;
      }
    }
  }
  .error-label {
    font-size: 16px;
    color: $error;
  }
  .submit-wrapper {
    margin: 40px 0;
  }
}
</style>
